import { createFileRoute } from '@tanstack/react-router';

import { WeeklySummaryPage } from '@/features/insights/weekly-pages';

/** Linked from the `weekly_summary` notification. */
export const Route = createFileRoute('/_app/projects/$projectId/insights/weekly/$summaryId')({
  component: WeeklySummaryRoute,
});

function WeeklySummaryRoute() {
  const { projectId, summaryId } = Route.useParams();
  return <WeeklySummaryPage projectId={projectId} summaryId={summaryId} />;
}
